<form [formGroup]="inhoudingsplichtigeFg">
  <div>
    <snelstart-ui-text-form-control formControlName="naamInhoudingsplichtige"
                                    id="naamInhoudingsplichtige"
                                    label="Naam vennootschap"
                                    [disabledControl]="true"
                                    class="custom-input-250"
    >
    </snelstart-ui-text-form-control>
  </div>
  <div>
    <snelstart-ui-bsn-form-control formControlName="rsinInhoudingsplichtige"
                                    id="rsinInhoudingsplichtige"
                                    label="RSIN/Fiscaal nummer"
                                   [disabledControl]="true"
                                   class="custom-input-250"
    >
    </snelstart-ui-bsn-form-control>
  </div>
</form>
